// extracted by mini-css-extract-plugin
export var faqPage = "index-module--faqPage--3NIb2";
export var fadein = "index-module--fadein--3HDNZ";
export var faqPageHeader = "index-module--faqPageHeader--25LeU";
export var faqContainer = "index-module--faqContainer--1j2yT";
export var faqSection = "index-module--faqSection--g2S0E";
export var faqHeader = "index-module--faqHeader--1h6yP";
export var faqText = "index-module--faqText--2Wymx";
export var faqWrapper = "index-module--faqWrapper--2Pd2N";
export var faqLink = "index-module--faqLink--HI1-K";